import { render, staticRenderFns } from "./DistributionPopup.vue?vue&type=template&id=052b8423&scoped=true&"
import script from "./DistributionPopup.vue?vue&type=script&lang=js&"
export * from "./DistributionPopup.vue?vue&type=script&lang=js&"
import style0 from "./DistributionPopup.vue?vue&type=style&index=0&id=052b8423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b8423",
  null
  
)

export default component.exports